import { sha256 } from 'js-sha256'

export const getSha256Hash = (value: string): string =>
  sha256(value.trim().toLowerCase())
